'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _arrowForward2x = require('assets/img/account/arrowForward@2x.png');

var _arrowForward2x2 = _interopRequireDefault(_arrowForward2x);

var _exu2x = require('assets/img/account/exu@2x.png');

var _exu2x2 = _interopRequireDefault(_exu2x);

var _reactRouter = require('react-router');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AccountItem, _Component);

  function AccountItem() {
    (0, _classCallCheck3.default)(this, AccountItem);
    return (0, _possibleConstructorReturn3.default)(this, (AccountItem.__proto__ || (0, _getPrototypeOf2.default)(AccountItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          extLink = _props.extLink,
          link = _props.link,
          icon = _props.icon,
          title = _props.title,
          exu = _props.exu,
          point = _props.point,
          leftArrow = _props.leftArrow,
          onClick = _props.onClick,
          customIconStyle = _props.customIconStyle;

      var styles = require('./AccountItem.scss');
      var content = _react2.default.createElement(
        'div',
        { className: styles.accountItemSetting },
        _react2.default.createElement('img', { src: icon, className: styles.img, style: customIconStyle }),
        _react2.default.createElement(
          'div',
          { className: styles.middleView },
          _react2.default.createElement(
            'div',
            { className: styles.textMiddle },
            title
          ),
          exu ? _react2.default.createElement(
            'div',
            { className: styles.pointView },
            _react2.default.createElement(
              'div',
              { className: styles.pointText },
              _support.Helper.formatMoney(point, ' ')
            ),
            _react2.default.createElement('img', { src: _exu2x2.default, style: { height: 8 } })
          ) : _react2.default.createElement(
            'div',
            { className: styles.arrowView },
            leftArrow && _react2.default.createElement(
              'div',
              { className: styles.leftArrow },
              leftArrow
            ),
            _react2.default.createElement('img', { src: _arrowForward2x2.default, className: styles.arrow })
          )
        )
      );
      return extLink ? _react2.default.createElement(
        'a',
        { href: extLink, onClick: onClick },
        content
      ) : _react2.default.createElement(
        _reactRouter.Link,
        { to: link, onClick: onClick },
        content
      );
    }
  }]);
  return AccountItem;
}(_react.Component), _class.propTypes = {
  extLink: _react.PropTypes.string,
  link: _react.PropTypes.string,
  icon: _react.PropTypes.any,
  title: _react.PropTypes.string,
  exu: _react.PropTypes.bool,
  point: _react.PropTypes.number,
  leftArrow: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  customIconStyle: _react.PropTypes.any
}, _temp);
exports.default = AccountItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/AccountItem.js
// module id = 1507
// module chunks = 0